export const keys = {
  configuration: ['configuration'],
} as const;
